<template>
    <div>
        <modal class="signature-qrcode" :display="modalStatus.signatureQrcode" @modalStatus="closeModal" >
            <h1>手機簽名</h1>
            <div class="signature-qrcode-wrap">
                <div class="description">
                    請掃描QRcode進行手機簽名，完成後重整網頁，簽名將帶入網頁畫面。注意：請於五分鐘內完成簽名，逾時QRcode將失效。
                </div>
                <vue-qrious class="qrcode" :value="hostUrl"  :size="size" level="L"/>
                <div class="count-down">
                    {{date}}
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="closeModal()">確認</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import VueQrious from 'vue-qrious'
import { mapGetters } from 'vuex'
import constant from '@/constant'
import { 
    baseWebUrl,
    apiBizGetSignatureCode,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            size: 140,
            signCode: null,
            date: '',
            countDwonObj: null,
        }
    },
    watch: {
        'modalStatus.signatureQrcode': {
            handler: function (val) {
                if(val){
                    this.getSignatureCode()
                }else{
                    this.clearCountDown()
                }
            },
            immediate: true
        }
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'signatureQrcode'})
        },
        getSignatureCode: function () {
            apiBizGetSignatureCode()
            .then( res => {
                if(res.data.status == 'SUCCESS'){
                    console.log(res.data.result)
                    this.signCode = res.data.result
                    this.countDown()
                }
            })
        },
        countDown: function () {
            var countDownDate = new Date().getTime()+300000;
            // console.log(countDownDate)
            var _self = this
            // Update the count down every 1 second
            this.countDwonObj = setInterval(function() {
                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = (Array(2).join(0)+Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
                var hours = (Array(2).join(0)+Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
                var minutes = (Array(2).join(0)+Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
                var seconds = (Array(2).join(0)+Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
                _self.date = minutes+" : "+seconds
              
                // If the count down is finished, write some text
                if (distance < 0) {
                    _self.clearCountDown()
                    _self.getSignatureCode()
                }
            }, 1000);
        },
        clearCountDown: function () {
            clearInterval(this.countDwonObj);
            this.date = "00 : 00"

        }
    },
    computed: {
        hostUrl: function () {
            let url = baseWebUrl
            return url + 'bizPhoneSigned?account='+this.userAccount+'&code='+this.signCode
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
            userAccount: 'GET_BIZ_USER_ACCOUNT',
        })
    },
    components: {
        Modal,
        VueQrious
    }
}
</script>
<style lang="scss"  >
    #modal.signature-qrcode{
        .modal-content{
            width: 372px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .signature-qrcode-wrap{
                    width: 308px;
                    box-sizing: border-box;
                    margin: 0 auto;
                    text-align: center;
                    .description{
                        position: relative;
                        margin-bottom: 20px;
                        color: #676362;
                        line-height: 1.5;
                    }
                    .count-down{
                        margin-bottom: 36px;
                    }
                }
            }
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 200px;
                    height: 44px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/signatureQrcode.vue